import { createIcon } from './createIcon';

/** Filled square — interrupt the run in flight. */
export const StopIcon = createIcon({
  name: 'StopIcon',
  viewBox: '0 0 16 16',
  size: 12,
  children: (
    <rect x="3" y="3" width="10" height="10" rx="1.5" fill="currentColor" />
  ),
});

export default StopIcon;
